import React from 'react';
import {SkeletonTheme} from 'react-loading-skeleton';
import PropertiesListSkeleton from "./skeleton/list";
import PropertiesGridSkeleton from "./skeleton/grid";

const PropertiesSkeleton = ({repeat = 3, className, gridView = false, windowSize}) => {
    const initArray = [...Array(repeat)];

    return (
        <SkeletonTheme color={props => props.theme.gray200} highlightColor="#444">
            {
                (gridView) ?
                    <div className="row">
                        {
                            initArray.map((key, i) =>
                                <PropertiesGridSkeleton className={className} windowSize={windowSize}/>
                            )
                        }
                    </div>
                    :
                    initArray.map((key, i) =>
                        <PropertiesListSkeleton className={className}/>
                    )
            }
        </SkeletonTheme>
    );
};

export default React.memo(PropertiesSkeleton);

